/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Toast from './sub_components/toast';
import * as apiUserService from '../services/apiUserService'
import { CSVLink } from 'react-csv';
import * as _ from 'lodash'
let linkClick
class ApiUser extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         cities_list: [],
         currencies_list: [],
         roles_list: [],
         user_accounts: [],
         accounts: '',
         user_id: "",
         cities: "",
         currencies: "",
         roles: "",
         users_data: [],
         csv_json: [],
         users_search_data: [],
         last_id: "",
         first_id: "",
         action: "",
         from: "",
         to: "",
         page_no: 1,
         count_records: 0,
         records_display: 25,
         toastMsg: "",
         toastType: "",
      };
   }
   async componentDidMount() {
      const { match: { params } } = this.props;
      if (params.user_id) {
         this.setState({ accounts: params.user_id })
      }
      let logKeys = await apiUserService.getApiUser()
      this.setState({ cities_list: logKeys.cities })
      this.setState({ currencies_list: logKeys.currencies })
      this.setState({ roles_list: logKeys.roles })
      if (this.state.accounts === "") {

         let userData = localStorage.getItem("tokenData")
         userData = JSON.parse(userData)
         if(!(!!userData && !!userData.sub)){
            localStorage.clear();
            this.props.history.push("/auth") 
         }
         this.userList(userData.sub)
         this.setState({ accounts: userData.sub })
      }
      else {
         this.userList(this.state.accounts)
      }
      let curDate = new Date().toISOString().split('T')[0]
      let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
      this.setState({ to: curDate, from: weekDate }, () => { this.onSubmit() })
   }
   componentWillUnmount(){
      clearTimeout(linkClick)
   }
   async userList(user_id) {
      const self = this;
      let body = {
         "user_id": user_id
      }
      body = this.clean(body);
      await apiUserService.postUserList(body).then((res) => {
         if (res.isSuccess) {
            self.setState(
               {
                  user_accounts: res.users_list
               }
            );
         } else {
            this.setState({ user_accounts: [] })
         }
      })
   }
   parseFilterBody() {
      let toDate = new Date(this.state.to)
      toDate = toDate.setHours(23, 59, 59, 999)
      let fromDate = new Date(this.state.from)
      fromDate = fromDate.setHours(0, 0, 0, 0)
      let body = {
         "filters": {
            "cities": [this.state.cities],
            "currencies": [this.state.currencies],
            "roles": [this.state.roles],
            "accounts": [this.state.accounts],
            "user_id": this.state.user_id
         },
         "last_id": this.state.last_id,
         "first_id": this.state.first_id,
         "action": this.state.action,
         "from": new Date(fromDate).toISOString(),
         "to": new Date(toDate).toISOString(),
         "page_no": this.state.page_no,
         "count_records": this.state.count_records,
         "records_display": this.state.records_display
      }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      await apiUserService.postApiUser(body).then((res) => {
         if (res.isSuccess) {
            self.setState(
               {
                  users_data: res.items,
                  users_search_data: res.items,
                  last_id: res.last_id,
                  first_id: res.first_id,
                  action: res.action,
                  page_no: res.page_no,
                  count_records: res.count_records
               }
            );
         } else {
            this.setState({ users_data: [], users_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
         }
      })
   }
   async onDownload() {
      const self = this;
      let body = this.parseFilterBody()
      await apiUserService.postApiUserCsv(body).then((res) => {
         this.setState({ csv_json: res }, () => {
            linkClick = setTimeout(function () {
               clearTimeout(linkClick)
               self.csvLink.current.link.click();
            }, 500)

         })
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   onUserSelect(e) {
      const value = e.target.name;
      this.setState({ accounts: value }, () => { this.userList(value); this.submitForm(); })

   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
          setTimeout(() => {
              self.setState({ toastMsg: "", toastType: "", showToast: false })
          }, 3000);
      })
  }
   onAction(e) {
      const value = e.target.name;
      let page_n = 0;
      if (value === "next") {
         page_n = this.state.page_no + 1;
      }
      if (value === "prev") {
         page_n = this.state.page_no - 1;
      }
      this.setState({ action: value, page_no: page_n }, () => { this.submitForm(); });
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (this.state.user_accounts.indexOf(this.state.user_id) === -1 && this.state.user_id !== "") {
         this.props.notify(" Username Not Exist. ", "error");
      }
      if (diffDays > 31) {
         this.props.notify(" Date range must be 1 month. ", "error");

      }
      else {
         this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
      }
   }
   resetForm() {
      let curDate = new Date().toISOString().split('T')[0]
      let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
      this.setState({ user_id: '', cities: '', currencies: '', roles: "", from: weekDate, to: curDate, users_data: [], users_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 }, () => { this.submitForm() })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "records_display") {
         this.setState({ [name]: value }, () => { this.submitForm() });
      }
      else {
         this.setState({ [name]: value });
      }
   }
   onSearch(e) {
      const value = e.target.value;
      if (this.state.users_search_data) {
         let users_lst = _.filter(this.state.users_search_data, function (obj) {
            return JSON.stringify(obj).indexOf(value) !== -1;
         });
         this.setState({ users_data: users_lst });
      }
   }
   render() {
      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
               <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
                  <ul>
                     <li><a href="list-of-clients.html">List of Clients</a></li>
                     <li><a href="#">Market Analysis</a></li>
                     <li><a href="import-event.html">Import Event</a></li>
                     <li>
                        <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                        <ul className="list-unstyled collapse" id="homeSubmenu" >
                           <li><a href="#">Test 1</a></li>
                        </ul>
                     </li>
                     <li>
                        <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                        <ul className="list-unstyled collapse" id="home1Submenu" >
                           <li><a href="#">Test 1</a></li>
                           <li><a href="#">Test 1</a></li>
                        </ul>
                     </li>
                  </ul>
               </div>
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">User Report</h5>
                           <div className="row mt-2">
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <input type="text" className="form-control" name="user_id" value={this.state.user_id} onChange={(e) => this.onChange(e)} title="User Name" placeholder="Search By UserName" />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <select onChange={(e) => this.onChange(e)} title="Cities" className="form-control" name="cities" value={this.state.cities}>
                                       <option value="">Select Cities</option>
                                       {this.state.cities_list.length > 0 ? this.state.cities_list.map((city, i) => <option key={i} value={city === null ? "null" : city === '' ? "blank" : city}>{city === null ? "Null" : city === '' ? "Blank" : city}</option>) : ""}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <select onChange={(e) => this.onChange(e)} title="Currencies" className="form-control" name="currencies" value={this.state.currencies}>
                                       <option value="">Select Currencies</option>
                                       {this.state.currencies_list.length > 0 ? this.state.currencies_list.map((currency, i) => <option key={i} value={currency === null ? "null" : currency === '' ? "blank" : currency}>{currency === null ? "Null" : currency === '' ? "blank" : currency}</option>) : ""}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <select onChange={(e) => this.onChange(e)} title="Roles" className="form-control" name="roles" value={this.state.roles}>
                                       <option value="">Select Roles</option>
                                       {this.state.roles_list.length > 0 ? this.state.roles_list.map((roles, i) => <option key={i} value={roles.id}>{roles.name}</option>) : ""}
                                    </select>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <input className="form-control" type="date" title="From" value={this.state.from} onChange={(e) => this.onChange(e)} id="from_datetime" name="from" />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12">
                                    <input className="form-control" type="date" title="To" value={this.state.to} onChange={(e) => this.onChange(e)} id="to_datetime" name="to" />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue" onClick={(e) => this.onSubmit(e)}>Go</button>
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                 </div>
                              </div>
                           </div>
                           <div className="row text-center my-2">
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                 <span className="d-inline search-report">Show</span>
                                 <div className="form-group font-12 float-left mb-0">
                                    <select onKeyPress={(e) => this.onAction(e)} onChange={(e) => { this.onChange(e) }} className="form-control" name="records_display" value={this.state.records_display}>
                                       <option value="25">25</option>
                                       <option value="50">50</option>
                                       <option value="100">100</option>
                                    </select>
                                 </div>
                                 <span className="d-inline search-report ml-2">entries</span>
                              </div>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-1">
                                 <div className="d-flex float-right">
                                    <CSVLink
                                       data={this.state.csv_json}
                                       filename={"User-Report.csv"}
                                       asyncOnClick={true}
                                       className="d-none"
                                       ref={this.csvLink}>
                                    </CSVLink>
                                    <button className="btn btn-dark btn-sm mr-2 d-inline" onClick={(e) => this.onDownload(e)} disabled={this.state.users_data.length > 0 ? false : true}><i className="fa fa-file-excel-o" aria-hidden="true"></i></button>
                                    <div className="form-group mb-0 d-inline">
                                       <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                 <div className="table-responsive">
                                    <table id="basic-btn" className="table font-14 table-bordered table-sm">
                                       <thead>
                                          <tr className="bg-dark text-white">
                                             <th>Name</th>
                                             <th>User Name</th>
                                             <th>Email</th>
                                             <th>Mobile</th>
                                             <th>City</th>
                                             <th>Remarks</th>
                                             <th title="Reference Name">RN</th>
                                             <th>Currency</th>
                                             <th>Role</th>
                                             <th>Credit Reference</th>
                                             <th>Deposit</th>
                                             <th>Balance</th>
                                             <th>Exposure</th>
                                             <th>Cash</th>
                                             <th>Parents</th>
                                             <th>Date</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {this.state.users_data.length > 0 ? this.state.users_data.map((user, i) => {
                                             let st = (user.created_at).split(" ")
                                             let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                             let dt = new Date(dtstr).toLocaleString()
                                             return (
                                                <tr key={i}>
                                                   <td>{user.name ? user.name : "-"}</td>
                                                   <td>{user.role !== 5 ? <><a className="hand" target='_blank' onClick={() => window.open("/apiuser/" + user.username, "_blank")} name={user.username} value={user.username}>{user.username ? user.username : "-"} </a> </> : <>{user.username ? user.username : "-"}</>}</td>
                                                   <td>{user.email ? user.email : "-"}</td>
                                                   <td>{user.mobile ? user.mobile : "-"}</td>
                                                   <td className="text-success">{user.city ? user.city : "-"}</td>
                                                   <td>{user.remarks ? user.remarks : "-"}</td>
                                                   <td>{user.reference_name ? user.reference_name : "-"}</td>
                                                   <td className="text-success">{user.currency ? user.currency : "-"}</td>
                                                   <td className="text-success">{user.role === 0 ? "S2S" : user.role === 1 ? "Admin" : user.role === 2 ? "SuperMaster" : user.role === 3 ? "SubSuperMaster" : user.role === 4 ? "Master" : user.role === 5 ? "Client" : user.role}</td>
                                                   <td className="text-right">{user.credit_ref ? user.credit_ref : "-"}</td>
                                                   <td className="text-right">{user.credit ? user.credit : "-"}</td>
                                                   <td className="text-right">{user.balance ? user.balance : "-"}</td>
                                                   <td className="text-right">{user.exposure ? user.exposure : "-"}</td>
                                                   <td className="text-right">{user.deposit ? user.deposit : "-"}</td>
                                                   <td>
                                                      {user.parents.length > 0 ? user.parents.map((parent, i) => {
                                                         return (
                                                            <>{user.parents.length - 1 === i ? parent : parent + " -> "}</>
                                                         )
                                                      })
                                                         : "-"}
                                                   </td>
                                                   <td className="text-success">{dt ? dt : "-"}</td>
                                                </tr>
                                             );
                                          }) : <tr>
                                                <td colSpan={15} align="center">
                                                   No Data Found.
                                             </td>
                                             </tr>}
                                       </tbody>
                                    </table>
                                 </div>
                                 <div className="row text-right">
                                    <div className="col-sm-12 col-md-12">
                                       <div className="btn-group my-2" role="group" aria-label="Basic example" id="divpagecount">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" ? true : false}>Prev</button>
                                          <button className="btn btn-blue" disabled>
                                             {
                                                this.state.page_no
                                             }
                                          </button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" ? true : false}>Next</button>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(ApiUser);